<template>
    <v-container fluid>
        <v-card class="header-card">
            <v-card-title class="card-title">Seasons</v-card-title>
            <div class="header-buttons">
                <v-btn class="my-2 mr-2" dark small color="black" @click="createSeason">
                    <v-icon dark>mdi-plus</v-icon>Create
                </v-btn>
            </div>
        </v-card>
        <array-view
            :items="seasons"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
        />
    </v-container>
</template>

<script>
    import seasonService from '@/services/season'
    import ArrayView from '@/components/ArrayView'

    export default {
        name: 'Season',
        components: { ArrayView },
        data: () => {
            return {
                successfullImport: null,
                seasons: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Year',
                        value: 'year'
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    },
                    {
                        text: 'Start Date',
                        value: 'startDate'
                    },
                    {
                        text: 'End Date',
                        value: 'endDate'
                    }
                ],
                showImportDialog: false,
                size: 100,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.page = this.$store.getters.getPage
            this.fetchAllSeasons()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchAllSeasons()
            },
            handleClick(action, item) {
                this.$router.push(`/seasons/${item.id}/${action}`)
            },
            onDelete(item, page) {
                seasonService.deleteSeason(item.id).then(() => {
                    this.page = page
                    this.fetchAllSeasons()
                })
            },
            createSeason() {
                this.$router.push(`/seasons/create`)
            },
            fetchAllSeasons() {
                seasonService.getSeasons(this.page, this.size).then(resp => {
                    this.seasons = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
